import { SwitchTogether } from 'react-together-ant-design'

export function AntDesignSwitchTogetherDemo() {
  return (
    <div className='flex-col place-items-center'>
      <SwitchTogether rtKey='input-switch-docs-demo' />
    </div>
  )
}
